import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import AppFooter from "../components/AppFooter";

const RegulatoryDisclaimer = () => {
  const navigate = useNavigate();

  const sections = [
    {
      title: "Investigational Features",
      content: `Certain Platform features, systems, models, outputs, or workflows may remain investigational, pilot-stage, or calibration-dependent and may evolve over time.`,
    },
    {
      title: "Regulatory Status",
      content: `Unless expressly stated otherwise, the Platform may not constitute a regulated medical device and may not have regulatory approvals in all jurisdictions.`,
    },
    {
      title: "No Certification Claims",
      content: `Nothing on the Platform shall be interpreted as FDA approval, CDSCO approval, diagnostic certification, medical certification, or guaranteed clinical efficacy unless explicitly stated in writing.`,
    },
    {
      title: "Intended Use",
      content: `The Platform is intended as an assistive preventive healthcare support system and not as an autonomous clinical decision-making system.`,
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-cyan-50 to-blue-100 relative overflow-hidden">

      {/* Background Glow */}
      <div className="absolute top-0 left-0 w-[400px] h-[400px] bg-white/30 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-[350px] h-[350px] bg-cyan-300/30 rounded-full blur-3xl"></div>

      {/* Grid */}
      <div className="absolute inset-0 opacity-[0.04] bg-[linear-gradient(to_right,#0f172a_1px,transparent_1px),linear-gradient(to_bottom,#0f172a_1px,transparent_1px)] bg-[size:40px_40px]"></div>

      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 py-10">

        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl sm:text-5xl font-bold text-slate-800">
            Regulatory Disclaimer
          </h1>

          <p className="mt-4 max-w-3xl mx-auto text-slate-600 text-sm sm:text-base leading-relaxed">
            Compliance and regulatory transparency notice for AICA HEALTH platform,
            AI systems, and healthcare support tools.
          </p>
        </div>

        {/* Sections */}
        <div className="space-y-6">
          {sections.map((sec, i) => (
            <div
              key={i}
              className="relative overflow-hidden rounded-3xl border border-white/40 bg-white/60 backdrop-blur-2xl shadow-xl p-6 sm:p-8 hover:bg-white/70 transition-all duration-300"
            >
              <h2 className="text-xl sm:text-2xl font-semibold text-slate-800 mb-3">
                {sec.title}
              </h2>

              <p className="text-slate-600 leading-relaxed text-sm sm:text-base">
                {sec.content}
              </p>
            </div>
          ))}
        </div>

        {/* Footer */}
         <div className="mt-10 flex justify-center">
       
                 <button
                   onClick={() => navigate("/")}
                   className="
                   flex items-center gap-2
                   px-6 py-3
                   rounded-2xl
                   bg-gradient-to-r from-cyan-500 to-blue-500
                   text-white
                   font-semibold
                   shadow-lg
                   hover:scale-105
                   hover:shadow-cyan-300/50
                   transition-all duration-300
                 "
                 >
                   <ArrowLeft size={18} />
                   Go Back
                 </button>
                </div>

       {/* <AppFooter /> */}
        
      </div>
    </div>
  );
};

export default RegulatoryDisclaimer;